export default "/fonts/vendor/@fontsource/lato/files/lato-latin-400-normal.woff2?be36596da218e1eec01c5c600b1c13ef";